export { DataInfo } from './DataInfo';
export type { Props } from './DataInfo.types';
